import { memo, useMemo, useCallback } from 'react';
import { Sky } from '@react-three/drei';
import { useStore } from '@immutabl3/store/react';
import { parallax } from '@immutabl3/alchemy/three';
import {
  Vector3,
  MathUtils,
} from 'three';

const ParallaxSky = parallax(Sky);

const SkyInstance = memo(function SkyInstance({
  animation,
  effects: skyEffects,
  ...props
}) {
  const sun = useMemo(() => new Vector3(), []);

  const onPercChange = useCallback((perc, ref) => {
    const sky = ref.current;
    if (!sky) return;

    if (animation) {
      const { duration, mixer } = animation;
      const tTime = duration * perc;
      if (mixer.time !== tTime) mixer.setTime(tTime); 
    }
    
    const uniforms = sky.material.uniforms;
    uniforms.turbidity.value = skyEffects.turbidity;
    uniforms.rayleigh.value = skyEffects.rayleigh;
    uniforms.mieCoefficient.value = skyEffects.mieCoefficient;
    uniforms.mieDirectionalG.value = skyEffects.mieDirectionalG;

    const phi = MathUtils.degToRad(90 - skyEffects.elevation);
    const theta = MathUtils.degToRad(skyEffects.azimuth);

    sun.setFromSphericalCoords(1, phi, theta);

    uniforms.sunPosition.value.copy(sun);
  }, [sun]);

  return (
    <ParallaxSky
      scale={ [450000, 450000, 450000] }
      onPercChange={ onPercChange }
      { ...props }
    />
  );
});

export default function SkyContainer(props) {
  const loaded = useStore(['loaded']);

  // NOTE: this is what's causing the light show
  // before rendering the tilescape / landscape
  if (!loaded) return null;

  return (
    <SkyInstance { ...props } />
  );
};